import { createDefaultLayout } from '../layout/createDefaultLayout';
import { defaultCatalogFlow, serializeCatalogFlow } from '../flow/catalogDoc';
import { catalogPath } from './catalogPaths';

export function nextFlatStoredPath(prefix: 'layout' | 'flow', paths: string[]): string {
  const re = new RegExp(`^/${prefix}(\\d+)\\.json$`, 'i');
  let max = -1;
  for (const p of paths) {
    const m = p.match(re);
    if (m) {
      max = Math.max(max, Number(m[1]));
    }
  }
  return `/${prefix}${max + 1}.json`;
}

export function defaultStoredFileContent(path: string): string {
  if (/^\/layout[0-9]+\.json$/i.test(path)) {
    return `${JSON.stringify(createDefaultLayout(), null, 2)}\n`;
  }
  if (/^\/flow[0-9]+\.json$/i.test(path)) {
    return serializeCatalogFlow(defaultCatalogFlow('flow'));
  }
  if (/^\/flows\/[A-Za-z0-9._-]+\.json$/i.test(path)) {
    const id = path.replace(/^\/flows\/|\.json$/gi, '');
    return serializeCatalogFlow(defaultCatalogFlow(id));
  }
  if (/^\/signals\/[A-Za-z0-9._-]+\.json$/i.test(path)) {
    return `${JSON.stringify({ metadata: { name: path.replace(/^\/signals\/|\.json$/gi, '') }, signals: [] }, null, 2)}\n`;
  }
  if (/^\/layouts\/[A-Za-z0-9._-]+\.json$/i.test(path)) {
    const layout = createDefaultLayout();
    layout.metadata.name = path.replace(/^\/layouts\/|\.json$/gi, '');
    return `${JSON.stringify(layout, null, 2)}\n`;
  }
  return '{}\n';
}

export function defaultFlowFileContent(name: string): string {
  return serializeCatalogFlow(defaultCatalogFlow(name));
}

export { catalogPath };
